import App from './App'
import uView from './uni_modules/vk-uview-ui';
import { initSentry, setSentryUser, clearSentryUser, captureError, setContext } from './utils/sentry';
import { trackPageView, trackButtonClick } from './utils/tracker';

import {
	createSSRApp
} from 'vue'

export function createApp() {

	const app = createSSRApp(App)
	
	// 初始化 Sentry
	initSentry(app);
	
	// 使用 uView UI
	app.use(uView)
	
	// 全局错误处理
	app.config.errorHandler = (err, vm, info) => {
		console.error('[Global Error Handler]', err, info);
		
		// 捕获到 Sentry
		captureError(err, {
			vueError: {
				info,
				componentName: vm?.$options?.name || 'Unknown',
			},
		});
	};
	
	// 全局混入：自动追踪页面访问
	app.mixin({
		onLoad(options) {
			// 获取当前页面路径
			const pages = getCurrentPages();
			const currentPage = pages[pages.length - 1];
			const route = currentPage?.route || 'Unknown';
			
			// 追踪页面访问
			trackPageView(route, options);
			
			// 设置 Sentry 上下文
			setContext('page', {
				route,
				options,
			});
		},
		onUnload() {
			// 页面卸载时可以清理一些追踪数据
			// 这里暂时不做处理
		},
	});
	
	// 挂载全局方法
	app.config.globalProperties.$sentry = {
		setSentryUser,
		clearSentryUser,
		trackButtonClick,
		trackPageView,
	};
	
	return {
		app
	}
}